import { Router } from '@angular/router';

import { AppRoutes } from '../models/routes.model';

export interface DetailResourceRoute {
  apiSegment: string;
  routeSegment: string;
}

/** Mapping tra endpoint API di dettaglio e sezioni dell'app ({base}/{id}). */
export const DETAIL_RESOURCE_ROUTES: DetailResourceRoute[] = [
  { apiSegment: 'admin/customers', routeSegment: AppRoutes.CUSTOMERS },
  { apiSegment: 'admin/tickets', routeSegment: AppRoutes.TICKET },
  { apiSegment: 'admin/operators', routeSegment: AppRoutes.OPERATOR },
];

const KNOWN_BASES = new Set(DETAIL_RESOURCE_ROUTES.map((r) => r.routeSegment));

function extractApiPath(url: string): string {
  try {
    return new URL(url, 'http://local').pathname.replace(/^\//, '');
  } catch {
    return url.replace(/^https?:\/\/[^/]+\//, '').replace(/^\//, '');
  }
}

function parseDetailResourceId(apiPath: string, apiSegment: string): string | null {
  const match = apiPath.match(new RegExp(`${apiSegment}/([^/?]+)$`));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Dalla URL corrente {base}/{id} restituisce {base}.
 * Es. /ticket/100 → ticket, /clienti/42 → clienti
 */
export function resolveListRouteFromCurrentUrl(router: Router): string | null {
  const segments = router.parseUrl(router.url).root.children['primary']?.segments ?? [];
  if (segments.length < 2) {
    return null;
  }

  const base = segments[0].path;
  const id = segments[1].path;

  if (!base || !id || id === 'nuovo' || !KNOWN_BASES.has(base)) {
    return null;
  }

  return base;
}

function resolveResourceForBase(base: string): DetailResourceRoute | undefined {
  return DETAIL_RESOURCE_ROUTES.find((r) => r.routeSegment === base);
}

/**
 * True se la GET 404 riguarda il dettaglio della sezione corrente ({base}/{id}).
 */
export function shouldHandleDetailNotFound(
  apiUrl: string,
  method: string,
  router: Router
): boolean {
  if (method !== 'GET') {
    return false;
  }

  const listRoute = resolveListRouteFromCurrentUrl(router);
  if (!listRoute) {
    return false;
  }

  const resource = resolveResourceForBase(listRoute);
  if (!resource) {
    return false;
  }

  const apiPath = extractApiPath(apiUrl);
  return parseDetailResourceId(apiPath, resource.apiSegment) !== null;
}
